<script setup lang="ts">
import { AlertTriangle } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { useUiStore } from '../../stores/ui'
import BaseModal from './BaseModal.vue'

const ui = useUiStore()
const { t } = useI18n()
</script>

<template>
  <BaseModal
    :open="Boolean(ui.confirmState)"
    :title="ui.confirmState?.title || ''"
    size="sm"
    @close="ui.resolveConfirm(false)"
  >
    <div class="confirm-copy">
      <span class="confirm-icon" :class="{ danger: ui.confirmState?.tone === 'danger' }">
        <AlertTriangle :size="24" />
      </span>
      <p>{{ ui.confirmState?.message }}</p>
    </div>
    <template #footer>
      <button class="button button-secondary" type="button" @click="ui.resolveConfirm(false)">{{ t('app.cancel') }}</button>
      <button
        class="button"
        :class="ui.confirmState?.tone === 'danger' ? 'button-danger' : 'button-primary'"
        type="button"
        @click="ui.resolveConfirm(true)"
      >
        {{ ui.confirmState?.confirmLabel || t('app.confirm') }}
      </button>
    </template>
  </BaseModal>
</template>
